import React from 'react'

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <div className="text-2xl font-bold mb-4">ResumeAI</div>
            <p className="text-gray-400 mb-4">
              Elevating your career prospects through AI-powered analysis and perfectly tailored resumes.
            </p>
            {/* <div className="flex space-x-4">
              <a href="/" className="text-gray-400 hover:text-white transition">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-twitter"
                >
                  <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
                </svg>
              </a>
              <a href="/" className="text-gray-400 hover:text-white transition">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-linkedin"
                >
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                  <rect x="2" y="9" width="4" height="12"></rect>
                  <circle cx="4" cy="4" r="2"></circle>
                </svg>
              </a>
              <a href="/" className="text-gray-400 hover:text-white transition">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-instagram"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
            </div> */}
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Product</h3>
            <ul className="space-y-2">
              <li>
                <a    href="/landing#features"    className="text-gray-400 hover:text-white transition"  >
                  Features
                </a>
              </li>
              {/* <li>
                <a    href="/"    className="text-gray-400 hover:text-white transition"  >
                  Pricing
                </a>
              </li> */}
              
              {/* <li>
                <a    href="/"    className="text-gray-400 hover:text-white transition"  >
                  Testimonials
                </a>
              </li> */}

              {/* <li>
                <a    href="/"    className="text-gray-400 hover:text-white transition"  >
                  FAQ
                </a>
              </li> */}
            </ul>
          </div>
          {/* <div>
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <a    href="/"    className="text-gray-400 hover:text-white transition"  >
                  Resume Tips
                </a>
              </li>
              <li>
                <a    href="/"    className="text-gray-400 hover:text-white transition"  >
                  Career Blog
                </a>
              </li>
              <li>
                <a    href="/"    className="text-gray-400 hover:text-white transition"  >
                  Job Search Guide
                </a>
              </li>
              <li>
                <a    href="/"    className="text-gray-400 hover:text-white transition"  >
                  Interview Prep
                </a>
              </li>
            </ul>
          </div> */}
          {/* <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <a    href="/"    className="text-gray-400 hover:text-white transition"  >
                  About Us
                </a>
              </li>
              <li>
                <a href="/" className="text-gray-400 hover:text-white transition">
                  Careers
                </a>
              </li>
              <li>
                <a     href="/"     className="text-gray-400 hover:text-white transition"
                >
                  Contact
                </a>
              </li>
              <li>
                <a
                  href="/" className="text-gray-400 hover:text-white transition">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div> */}
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>
            &copy; {new Date().getFullYear()} ResumeAI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
